import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { PatientService } from '../../../core/services/patient.service';
import { UtilitiesHelper } from '../../../core/helpers/utilities.helper';

@Component({
  selector: 'app-patient-create',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './patient-create.component.html'
})
export class PatientCreateComponent {

  nome = '';

  cognome = '';

  genere = '';

  dataNascita = '';

  success = '';

  error = '';

  duplicatePatient: any = null;

  showDuplicateModal = false;

  @Input()
  selectionMode = false;

  @Output()
  patientSelected =
    new EventEmitter<any>();

    public utilitiesHelper = UtilitiesHelper;

  constructor(
    private patientService: PatientService,
    private router: Router
  ) { }

  save() {

    this.success = '';
    this.error = '';

    const request = {

      nome: this.nome,

      cognome: this.cognome,

      genere: this.genere || null,

      dataNascita:
        this.dataNascita || null
    };

    // CHECK DUPLICATI

    this.patientService
      .checkDuplicate(request)
      .subscribe({

        next: (duplicate) => {

          if (duplicate) {

            this.showDuplicate(duplicate);

            return;
          }

          // NESSUN DUPLICATO

          this.createPatient(request);
        },

        error: (error: HttpErrorResponse) => {

          const duplicate = this.extractDuplicateFromError(error);

          if (duplicate) {

            this.showDuplicate(duplicate);

            return;
          }

          // Fallback: do not block patient creation because duplicate-check failed.
          this.createPatient(request);
        }
      });
  }

  private showDuplicate(duplicate: any) {

    this.duplicatePatient = duplicate;
    this.showDuplicateModal = true;
  }

  private extractDuplicateFromError(error: HttpErrorResponse): any | null {

    const payload = error?.error;

    if (!payload) {

      return null;
    }

    if (payload?.idPaziente) {

      return payload;
    }

    const candidates = [
      payload?.duplicate,
      payload?.duplicatePatient,
      payload?.existingPatient,
      payload?.data,
      payload?.result
    ];

    for (const candidate of candidates) {

      if (candidate?.idPaziente) {

        return candidate;
      }
    }

    return null;
  }

  resetForm() {

    this.nome = '';

    this.cognome = '';

    this.genere = '';

    this.dataNascita = '';
  }

  createPatient(request: any) {

    this.patientService
      .create(request)
      .subscribe({

        next: (patient) => {

          if (this.selectionMode) {

            this.patientSelected.emit(patient);

            return;
          }

          this.router.navigate([
            '/patients',
            patient.idPaziente
          ]);
        },

        error: (error: HttpErrorResponse) => {

          const duplicate = this.extractDuplicateFromError(error);

          if (duplicate) {

            this.showDuplicate(duplicate);

            this.error = '';

            return;
          }

          if (error?.status === 409) {

            this.error =
              'Paziente duplicato rilevato. Riprova e seleziona il paziente esistente.';

            return;
          }

          this.error =
            'Errore durante il salvataggio';
        }
      });
  }

  createAnyway() {

    const request = {

      nome: this.nome,

      cognome: this.cognome,

      genere: this.genere || null,

      dataNascita:
        this.dataNascita || null
    };

    this.showDuplicateModal = false;

    this.createPatient(request);
  }

  selectExistingPatient() {

    this.showDuplicateModal = false;

    if (this.selectionMode) {

      this.patientSelected.emit(
        this.duplicatePatient
      );

      return;
    }

    this.router.navigate([
      '/patients',
      this.duplicatePatient.idPaziente
    ]);
  }

  goHome() {

    this.router.navigate(['/home']);
  }

}